<form *ngIf="filterVal" (ngSubmit)="search()" style="width: 100%">
  <div class="form-grid wrap filterPanel form-group p-2">
    <div>
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="filterVal.filters.regNo.value" />
        <label>Reg.No.</label>
      </span>
    </div>

    <div>
      <span class="md-inputfield filterItem">
        <input name="from" type="text" pInputText [(ngModel)]="filterVal.filters.from.value" />
        <label>From Location</label>
      </span>
    </div>

    <div>
      <span class="md-inputfield filterItem">
        <input name="to" type="text" pInputText [(ngModel)]="filterVal.filters.to.value" />
        <label>To Location</label>
      </span>
    </div>

    <div *ngIf="inboxType == inboxType_VmeInbox">
      <p-multiSelect
        name="customers"
        [options]="customers"
        [(ngModel)]="filterVal.filters.customerIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Customers"
      ></p-multiSelect>
      <!--<p-dropdown name="customers" [options]="customers" [(ngModel)]="filterVal.filters.customerId.value"
                  styleClass="filterItem" [style]="{'width':'100%'}"></p-dropdown>-->
    </div>

    <div *ngIf="inboxType == inboxType_VmeInbox">
      <p-multiSelect
        name="suppliers"
        [options]="suppliers"
        [(ngModel)]="filterVal.filters.supplierIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Suppliers"
      ></p-multiSelect>
      <!--<p-dropdown name="suppliers" [options]="suppliers" [(ngModel)]="filterVal.filters.supplierId.value"
                  styleClass="filterItem" [style]="{'width':'100%'}"></p-dropdown>-->
    </div>

    <div>
      <p-multiSelect
        name="taskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.taskTypeList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Customer Task Types"
      ></p-multiSelect>
      <!--<p-dropdown name="taskTypes" [options]="taskTypes" [(ngModel)]="filterVal.filters.taskType.value"
                  styleClass="filterItem" [style]="{'width':'100%'}"></p-dropdown>-->
    </div>

    <div>
      <p-multiSelect
        name="actualTaskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.actualTaskTypeList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Engineius Service Types"
      ></p-multiSelect>
      <!--<p-dropdown name="taskTypes" [options]="taskTypes" [(ngModel)]="filterVal.filters.taskType.value"
                  styleClass="filterItem" [style]="{'width':'100%'}"></p-dropdown>-->
    </div>

    <div *ngIf="inboxType == inboxType_VmeInbox">
      <p-multiSelect
        name="eareas"
        [options]="eareas"
        [(ngModel)]="filterVal.filters.eareaIdList.value"
        (onChange)="populateERegions()"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Regions"
      ></p-multiSelect>
    </div>

    <div *ngIf="inboxType == inboxType_VmeInbox">
      <p-multiSelect
        name="eregions"
        [options]="eregions"
        [(ngModel)]="filterVal.filters.eregionIdList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Areas"
      ></p-multiSelect>
      <!--<p-dropdown name="eregions" [options]="eregions" [(ngModel)]="filterVal.filters.eregionId.value"
                  styleClass="filterItem" [style]="{'width':'100%'}"></p-dropdown>-->
    </div>

    <div>
      <p-multiSelect
        *ngIf="inboxType == inboxType_VmeInbox && taskStatuses"
        name="taskStatus"
        [options]="taskStatuses"
        [(ngModel)]="filterVal.filters.taskStatusList.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        defaultLabel="All Task Statuses"
      ></p-multiSelect>

      <p-dropdown
        *ngIf="inboxType != inboxType_VmeInbox"
        name="taskSteps"
        [options]="taskSteps"
        [(ngModel)]="filterVal.filters.taskStep.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="square-buttons">
      <button pButton type="submit" icon="ui-icon-search"></button>
      <button pButton type="button" icon="ui-icon-close" (click)="clearFilter()"></button>
      <button pButton type="button" icon="ui-icon-refresh" (click)="refresh()"></button>
    </div>
  </div>
</form>

<p-table
  #dataTable
  *ngIf="inboxType != inboxType_VmeInbox"
  selectionMode="single"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  [value]="page.items"
  [rows]="filterVal.rows"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  [first]="filterVal.first"
  [lazy]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
  [pageLinks]="8"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  resizableColumns="true"
  (onRowSelect)="onRowSelect($event)"
  [hidden]="!isLoaded"
  [(selection)]="selectedItem"
  styleClass="inbox-data-table dataTable"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="registrationNumber">Reg. No.</th>
      <th pSortableColumn="pickupLocation">From</th>
      <th pSortableColumn="dropoffLocation">To</th>
      <th pSortableColumn="pickupLatest">Latest Pickup</th>
      <th pSortableColumn="dropoffLatest">Latest Dropoff</th>
      <th pSortableColumn="MovementType">Movement Type</th>
      <th pSortableColumn="lastStepDateTime">Status</th>
      <th pSortableColumn="eRegion">Region</th>
      <th pSortableColumn="vehiclesNum">Vehicles</th>
      <th
        pSortableColumn="price"
        *ngIf="inboxType == inboxType_VmeInbox || inboxType == inboxType_SupplierExistingJobs"
      >
        Supplier Paid
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr class="no-wrap-cells" [pSelectableRow]="item" (dblclick)="editJob(item, $event)">
      <td>
        <div title="{{ item.vehicle.registrationNumber }}">
          {{ item.vehicle.registrationNumber }}
        </div>
      </td>
      <td>
        <div title="{{ inboxjobsService.addressStr(item.pickupLocation) }}">
          {{ inboxjobsService.addressStr(item.pickupLocation) }}
        </div>
      </td>
      <td>
        <div title="{{ inboxjobsService.addressStr(item.dropoffLocation) }}">
          {{ inboxjobsService.addressStr(item.dropoffLocation) }}
        </div>
      </td>
      <td>
        <div title="Earliest: {{ item.pickupEarliestDateTime | datex : 'ddd DD MMM \'YY HH:mm' }}">
          {{ item.pickupLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </td>
      <td>
        <div title="Earliest: {{ item.dropoffEarliestDateTime | datex : 'ddd DD MMM \'YY HH:mm' }}">
          {{ item.dropoffLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </td>
      <td>
        <div title="{{ item.taskType?.name }}">{{ item.taskType.abbr }}</div>
      </td>
      <td>
        <div
          pTooltip="{{
            item.lastStepDesc + '\n' + (item.lastStepDateTime | datex : 'ddd DD MMM \'YY HH:mm')
          }}"
        >
          {{ item.lastStepName }}
        </div>
      </td>
      <td>
        <div title="{{ item.eRegion }}">{{ item.eRegion }}</div>
      </td>
      <td>{{ item.vehiclesNum }}</td>
      <td *ngIf="inboxType == inboxType_VmeInbox || inboxType == inboxType_SupplierExistingJobs">
        {{ item.price | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLES DEPRECATED --

<p-dataTabl #dataTable *ngIf="inboxType!=inboxType_VmeInbox" selectionMode="single" [sortField]="filterVal.sortField"
             [sortOrder]="filterVal.sortOrder" [value]="page.items" [rows]="filterVal.rows"
             [responsive]="true" [paginator]="true" rowHover="true" [first]="filterVal.first"
             [lazy]="true" [rowsPerPageOptions]="[5,10,20,50,100]" [pageLinks]="8"
             [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
             resizableColumns="true" (onRowSelect)="onRowSelect($event)" [hidden]="!isLoaded"
             [(selection)]="selectedItem" styleClass="inbox-data-table dataTable"
             (onRowDblclick)="editJob(selectedItem)">
  <p-column field="registrationNumber" header="Reg. No." [sortable]="tru" [editable]="false" [style]="{'width': '8%'}">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{ item.vehicle.registrationNumber }}">
        {{item.vehicle.registrationNumber}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="pickup" header="From" [sortable]="tru" [editable]="false" [style]="{'width': '15%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{inboxjobsService.addressStr(item.pickupLocation)}}">
        {{inboxjobsService.addressStr(item.pickupLocation)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="dropoff" header="To" [sortable]="tru" [editable]="false" [style]="{'width': '15%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{inboxjobsService.addressStr(item.dropoffLocation)}}">
        {{inboxjobsService.addressStr(item.dropoffLocation)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="pickupLatest" header="Latest Pick-up" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="Earliest: {{item.pickupEarliestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">
        {{item.pickupLatestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="dropoffLatest" header="Latest Drop-Off" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="Earliest: {{item.dropoffEarliestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">
        {{item.dropoffLatestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="movementType" header="Movement Type" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.taskType?.name}}">{{item.taskType.abbr}}</div>
    </ng-template>
  </p-column>
  <p-column field="lastCompletedStep" header="Current Step" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.lastStepDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">{{item.lastStepName}}</div>
    </ng-template>
  </p-column>
  <p-column field="eRegion" header="Region" [sortable]="false" [editable]="false"
            *ngIf="inboxType==inboxType_VmeInbox" [style]="{'width': '10%'}">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{item.eRegion}}">{{item.eRegion}}</div>
    </ng-template>
  </p-column>
  <p-column field="vehiclesNum" header="Vehicles" [sortable]="false" [editable]="false"
            [style]="{'text-align' : 'center', 'width': '4%'}"></p-column>
  <p-column field="price" header="Supplier Paid" [sortable]="tru" [editable]="false"
            [style]="{'text-align' : 'center', 'width': '7%'}"
            *ngIf="inboxType==inboxType_VmeInbox || inboxType==inboxType_SupplierExistingJobs">
    <ng-template let-item="rowData" pTemplate="body">
      {{ item.price | currency:'GBP':'symbol':'1.2-2' }}
    </ng-template>
  </p-column>
</p-dataTable>

-->

<p-progressBar
  *ngIf="showProgress || isLoading"
  mode="indeterminate"
  class="ui-progressbar-indeterminate"
></p-progressBar>

<p-table
  #dataTable
  *ngIf="inboxType == inboxType_VmeInbox"
  selectionMode="single"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  [value]="page.items"
  [rows]="filterVal.rows"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  [first]="filterVal.first"
  [lazy]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
  [pageLinks]="8"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  resizableColumns="true"
  (onRowSelect)="onRowSelect($event)"
  [hidden]="!isLoaded"
  [(selection)]="selectedItem"
  styleClass="inbox-data-table dataTable"
  [loading]="isLoading"
>
  <ng-template pTemplate="header">
    <tr class="no-wrap-cells">
      <th></th>
      <th style="width: 50px"></th>
      <th pSortableColumn="firstTaskCompleted">Job Start Date</th>
      <th pSortableColumn="registrationNumberDetails">Vehicle Reg</th>
      <th pSortableColumn="pickupLocation">From</th>
      <th pSortableColumn="dropoffLocation">To</th>
      <th pSortableColumn="pickupZoneName">Collection Ops Zone</th>
      <th pSortableColumn="deliveryZoneName">Delivery Ops Zone</th>
      <th pSortableColumn="pickupLatest">Earliest Pickup</th>
      <th pSortableColumn="dropoffLatest">Earliest Dropoff</th>
      <th pSortableColumn="MovementType">Movement Type</th>
      <th pSortableColumn="customerName">Customer</th>
      <th>Dept.</th>
      <th>Team</th>
      <th pSortableColumn="supplierName">Supplier</th>
      <th pSortableColumn="lastStepDateTime">Status</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr (dblclick)="editJob(item, $event)" class="no-wrap-cells" [pSelectableRow]="item">
      <td style="width: 20px">
        <div class="incident-icons">
          <i
            *ngIf="item.openMessageCount > 0"
            pTooltip="{{ item.openMessageCount }} Open Incident Messages"
            class="material-icons"
            >mail_outline</i
          >
          <i
            *ngIf="item.openIncidentCount > 0"
            style="color: #ff8f00"
            pTooltip="{{ item.openIncidentCount }} Open Incidents"
            class="material-icons"
            >report_problem</i
          >
        </div>
      </td>
      <td>
        <div class="flex align-content-center gap-1 justify-content-center">
          <route-icon *ngIf="rowIsRoute(item)"></route-icon>
          <span *ngIf="checkCarryOverAuthorised(item)" pTooltip="Carry-Over Authorised"
            ><img src="/assets/images/carryOver_icon.png" style="height: 20px"
          /></span>
        </div>
      </td>
      <td>
        <div title="{{ item.firstTaskCompleted | datex : 'ddd DD MMM \'YY HH:mm' }}">
          {{ item.firstTaskCompleted | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </td>
      <td>
        <div title="{{ vehicleCountPostfix(item, item.vehicle.registrationNumberDetails) }}">
          {{ vehicleCountPostfix(item, item.vehicle.registrationNumber) }}
        </div>
      </td>
      <td>
        <div title="{{ inboxjobsService.addressStr(item.pickupLocation) }}">
          {{ inboxjobsService.addressStr(item.pickupLocation) }}
        </div>
      </td>
      <td>
        <div title="{{ inboxjobsService.addressStr(item.dropoffLocation) }}">
          {{ inboxjobsService.addressStr(item.dropoffLocation) }}
        </div>
      </td>
      <td>
        <div title="{{ item.pickupZoneName }}">{{ item.pickupZoneName }}</div>
      </td>
      <td>
        <div title="{{ item.deliveryZoneName }}">{{ item.deliveryZoneName }}</div>
      </td>
      <td>
        <div pTooltip="Latest: {{ item.pickupLatestDateTime | datex : 'ddd DD MMM \'YY HH:mm' }}">
          {{ item.pickupEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
          {{ getPickupDropoffDiffHours(item, true) }}
        </div>
      </td>
      <td>
        <div pTooltip="Latest: {{ item.dropoffLatestDateTime | datex : 'ddd DD MMM \'YY HH:mm' }}">
          {{ item.dropoffEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
          {{ getPickupDropoffDiffHours(item, false) }}
        </div>
      </td>
      <td>
        <div title="{{ item.taskType?.name }}">{{ item.taskType.abbr }}</div>
      </td>
      <td>
        <div title="{{ item.customerInfo?.name }}">
          {{ item.customerInfo?.name }}
        </div>
      </td>
      <td>
        <div title="{{ item.departmentInfo?.name }}">
          {{ item.departmentInfo?.name }}
        </div>
      </td>
      <td>
        <div title="{{ item.teamInfo?.name }}">
          {{ item.teamInfo?.name }}
        </div>
      </td>
      <td>
        <div title="{{ item.supplierName }}">
          {{ item.supplierName }}
        </div>
      </td>
      <td>
        <div
          pTooltip="{{
            item.lastStepDesc + '\n' + (item.lastStepDateTime | datex : 'ddd DD MMM \'YY HH:mm')
          }}"
        >
          {{ item.lastStepName }}
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLES DEPRECATED ---
<p-dataTabl #dataTable *ngIf="inboxType==inboxType_VmeInbox" selectionMode="single" [sortField]="filterVal.sortField"
             [sortOrder]="filterVal.sortOrder" [value]="page.items" [rows]="filterVal.rows"
             [responsive]="true" [paginator]="true" rowHover="true" [first]="filterVal.first"
             [lazy]="true" [rowsPerPageOptions]="[5,10,20,50,100]" [pageLinks]="8"
             [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
             resizableColumns="true" (onRowSelect)="onRowSelect($event)" [hidden]="!isLoaded"
             [(selection)]="selectedItem" styleClass="inbox-data-table dataTable"
             (onRowDblclick)="editJob(selectedItem)" [loading]="isLoading">

  <p-column [resizable]="false" [editable]="false"
            [style]="{'text-align' : 'center', 'width': '30px', 'padding': '0px'}" [sortable]="false">
    <ng-template let-item="rowData" pTemplate="body">
      <div class="incident-icons">
        <i *ngIf="item.openMessageCount > 0" pTooltip="{{ item.openMessageCount }} Open Incident Messages"
           class="material-icons">mail_outline</i>
        <i *ngIf="item.openIncidentCount > 0" style="color: #FF8F00;"
           pTooltip="{{ item.openIncidentCount }} Open Incidents" class="material-icons">report_problem</i>
      </div>
    </ng-template>
  </p-column>

  <p-column field="firstTaskCompleted" header="Job Start Date" [sortable]="tru" [editable]="false"
            [style]="{'width': '9%'}">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{item.firstTaskCompleted | datex:'ddd DD MMM \'YY HH:mm'}}">
        {{item.firstTaskCompleted | datex:'ddd DD MMM \'YY HH:mm'}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="registrationNumber" header="Vehicle Reg" [sortable]="tru" [editable]="false">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{vehicleCountPostfix(item, item.vehicle.registrationNumberDetails)}}">
        {{vehicleCountPostfix(item, item.vehicle.registrationNumber)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="pickup" header="From" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{inboxjobsService.addressStr(item.pickupLocation)}}">
        {{inboxjobsService.addressStr(item.pickupLocation)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="dropoff" header="To" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{inboxjobsService.addressStr(item.dropoffLocation)}}">
        {{inboxjobsService.addressStr(item.dropoffLocation)}}
      </div>
    </ng-template>
  </p-column>

  <p-column field="pickupZoneName" header="Collection Ops Zone" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{item.pickupZoneName}}">{{item.pickupZoneName}}</div>
    </ng-template>
  </p-column>

  <p-column field="deliveryZoneName" header="Delivery Ops Zone" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template let-item="rowData" pTemplate="body">
      <div title="{{item.deliveryZoneName}}">{{item.deliveryZoneName}}</div>
    </ng-template>
  </p-column>

  <p-column field="pickupEarliest" header="Earliest Pick-up" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div pTooltip="Latest: {{item.pickupLatestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">
        {{item.pickupEarliestDateTime | datex:'ddd DD MMM \'YY HH:mm'}} {{getPickupDropoffDiffHours(item, true)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="dropoffEarliest" header="Earliest Drop-off" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}">
    <ng-template pTemplate="body" let-item="rowData">
      <div pTooltip="Latest: {{item.dropoffLatestDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">
        {{item.dropoffEarliestDateTime | datex:'ddd DD MMM \'YY HH:mm'}} {{getPickupDropoffDiffHours(item, false)}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="movementType" header="Movement Type" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.taskType?.name}}">{{item.taskType.abbr}}</div>
    </ng-template>
  </p-column>
  <p-column field="customerName" header="Customer" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.customerInfo?.name}}">
        {{item.customerInfo?.name}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="customerDepartmentName" header="Dept." [sortable]="false" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.departmentInfo?.name}}">
        {{item.departmentInfo?.name}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="customerTeamName" header="Team" [sortable]="false" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.teamInfo?.name}}">
        {{item.teamInfo?.name}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="supplierName" header="Supplier" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.supplierName}}">
        {{item.supplierName}}
      </div>
    </ng-template>
  </p-column>
  <p-column field="lastCompletedStep" header="Current Step" [sortable]="tru" [editable]="false">
    <ng-template pTemplate="body" let-item="rowData">
      <div title="{{item.lastStepDateTime | datex:'ddd DD MMM \'YY HH:mm'}}">{{item.lastStepName}}</div>
    </ng-template>
  </p-column>
</p-dataTable>

-->

<div class="footerPanel ui-grid-row">
  <button
    class="btn-to-right"
    type="button"
    (click)="editJob(selectedItem, $event)"
    icon="fa fa-list"
    [label]="organisationTypeId == 2 ? 'Order Details' : 'Job Details'"
    pButton
    [disabled]="!selectedItem"
  ></button>
  <button
    *ngIf="inboxType == inboxType_VmeInbox"
    class="btn-to-right"
    icon="fa fa-cloud-download"
    type="button"
    (click)="downloadToCSV()"
    label="Download to CSV"
    pButton
  ></button>
  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="showPriceDetails(selectedItem)"
    icon="fa fa-info"
    label="Price Details"
    pButton
    [disabled]="!selectedItem"
    *ngIf="!hasCustomerBookingRole && !hasCustomerPriceRole"
  ></button>
</div>

<ng-template #loading>Loading...</ng-template>
